import { TextStyle } from 'pixi.js'
import { Container, Text } from '@pixi/react'
import { useAutoPlayStore } from '../../domain/autoPlay/store/autoPlayStore'
import { Button } from '../../UI/Button'
import { Image } from '../../UI/Image'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { autoPlayService } from '../../domain/autoPlay'

interface AutoButtonProps {
  x: number
  y: number
  width: number
  height?: number
  enabled?: boolean
  normalView?: string
  hoverView?: string
  pressedView?: string
  disabledView?: string
}

export const AutoButtonV2 = (props: AutoButtonProps) => {
  const [isPlaying, current] = useAutoPlayStore(x => [x.isPlaying, x.current])

  if (isPlaying) {
    return (
      <Container name="auto on" x={props.x} y={props.y}>
        <Image image="auto_bg_v2" name="auto_bg_v2" />
        <Button
          name="stop auto button"
          x={12}
          y={15}
          width={90}
          height={90}
          defaultView="auto_off_normal_v2"
          hoverView="auto_off_hover_v2"
          disabledView="auto_off_disabled_v2"
          pressedView="auto_off_click_v2"
          enabled={true}
          onPress={() => {
            soundManager.play(SoundType.buttonClose)
            autoPlayService.cancel()
          }}
        />
        {current === 'infinity'
          ? (
              <Image x={120} y={40} width={80} height={45} image="auto_icon_infinity_v2" />
            )
          : (
              <Text
                text={current.toString()}
                x={170}
                y={60}
                anchor={[0.5, 0.5]}
                style={
                  new TextStyle({
                    fontSize: 54,
                    fontWeight: 'bold',
                    fill: '#ffffff',
                    align: 'center',
                  })
                }
              />
            )}
      </Container>
    )
  }

  return (
    <Button
      name="auto button three"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height || props.width}
      defaultView="auto_normal_v2"
      hoverView="auto_hover_v2"
      disabledView="auto_disable_v2"
      pressedView="auto_click_v2"
      enabled={props.enabled}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={() => {
        useAutoPlayStore.setState({
          isEnabledPanel: true,
        })
      }}
    />
  )
}
